<a
  class="sav-trending-coupon-brand"
  [routerLink]="storePath() || null"
  [attr.aria-label]="storeName()"
>
  <!-- The logo, or the store's name in a white circle when there is none (or it fails to load).
       `.sav-trending-coupon-brand-logo` stays on the slot: that global rule is what sizes it (92px,
       80px on phones) and draws the ring, so the card's geometry does not move. Decorative because
       the link's aria-label already names the store. -->
  <app-store-logo
    class="sav-trending-coupon-brand-logo"
    [logoUrl]="logoUrl()"
    [name]="storeName()"
    decorative
  />
</a>

<div class="sav-trending-coupon-content">
  <!-- Offer-type chip, a hairline rule, then the Verified pill. -->
  <div class="sav-trending-coupon-top-row">
    <span class="sav-trending-coupon-type">{{ ctaType() === 'code' ? 'Code' : 'Deal' }}</span>
    <span class="sav-trending-coupon-verified">Verified</span>
  </div>

  <a class="sav-trending-coupon-store" [routerLink]="storePath() || null">{{ storeName() }}</a>

  <!-- Body copy, not a heading: `.type-inherit` is the design system's opt-out, so the size comes
       from the card rather than the heading scale. -->
  <h3 class="type-inherit">{{ title() }}</h3>

  <div class="sav-trending-coupon-bottom-row">
    <span>{{ expiryLabel() }} : {{ expiryValue() }}</span>
    <!-- Just "Reveal Code" — no fragment of the code. The code itself belongs in the popup the CTA
         opens; printing part of it here gave it away before the click was made. -->
    @if (ctaType() === 'code') {
      <a [href]="ctaHref() || '#'" (click)="onCta($event)"
        ><span class="sav-trending-coupon-code-label">Reveal Code</span></a
      >
    } @else {
      <a [href]="ctaHref() || '#'" class="deal" (click)="onCta($event)">Get Deal</a>
    }
  </div>
</div>
